/* eslint-disable no-undef */

export default function rlxTracking() {
    const selectors = {
        contactCall: '.js_track-call', // rlx + cpo
        findStore: '.js_track-store', // rlx + cpo
        storeDirection: '.js_track-map', // rlx + cpo
        showMore: '.js_detail-link', // rlx
        downloadBrochure: '.js_track-download-brochure', // rlx
        addToWishlist: '.js_track-add-to-wishlist', // cpo
        addToBag: '.js_track-add-to-bag', // cpo
        contactForm: '.js_track-contact-form', // cpo
        bookAppointment: '.js_track-book-appointment', // cpo
    };

    const hasMarketingConsent = () => __cmp('getCMPData').purposeConsents.c52 !== undefined;
    const hasStatsConsent = () => __cmp('getCMPData').purposeConsents.c31 !== undefined;
    const hasSatellite = () => typeof _satellite === 'object';

    const getDataLayer = () => window.dataLayer;
    const getStoreName = event =>
        $(event.target.closest('.js-rlx-v7-store-details')).find('[data-store-name]').attr('data-store-name');

    const bindClick = (selector, handler) => {
        $(document).on('click', selector, handler);
    };

    const trackSatellite = (eventName, requireConsent = false) => {
        if (!hasSatellite()) return;
        if (requireConsent && (!hasMarketingConsent() || !hasStatsConsent())) return;
        _satellite.track(eventName);
    };

    const pushDataLayer = (payload) => {
        getDataLayer().push(payload);
    };

    bindClick(selectors.contactCall, (event) => {
        trackSatellite('contactCall', true);
        pushDataLayer({
            event: 'rolex_niederlassung_phone',
            niederlassung: getStoreName(event),
        });
    });

    bindClick(selectors.findStore, () => {
        trackSatellite('findStore');
        pushDataLayer({ event: 'rolex_cpo_find_store' });
    });

    bindClick(selectors.storeDirection, (event) => {
        trackSatellite('getDirections');
        pushDataLayer({
            event: 'rolex_niederlassung_route',
            niederlassung: getStoreName(event),
        });
    });

    bindClick(selectors.showMore, (event) => {
        pushDataLayer({
            event: 'rolex_niederlassung_moreinformation',
            niederlassung: getStoreName(event),
        });
    });

    bindClick(selectors.downloadBrochure, () => {
        trackSatellite('download');
    });

    bindClick(selectors.addToWishlist, () => {
        trackSatellite('addToWishlist');
        pushDataLayer({ event: 'rolex_cpo_add_to_wishlist' });
    });

    bindClick(selectors.addToBag, () => {
        trackSatellite('addToBag');
        pushDataLayer({ event: 'rolex_cpo_add_to_bag' });
    });

    bindClick(selectors.contactForm, () => {
        trackSatellite('contactForm');
        pushDataLayer({ event: 'rolex_cpo_contact_form' });
    });
    bindClick(selectors.bookAppointment, () => {
        trackSatellite('bookAppointment');
        pushDataLayer({ event: 'rolex_cpo_book_appointment' });
    });
}
